const attendeeStatuses = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  MAY_BE: 'MAY_BE',
  DECLINED: 'DECLINED'
};

export default attendeeStatuses;